/* import __COLOCATED_TEMPLATE__ from './basic.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './basic.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsNoteDiagnosisTreatmentPlanBasic extends Component {}
